import {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import { Gallery, GalleryItem, Image, Overlay, Title, Tags, ViewText } from "../styles/ProjectGridStyle";
import { 
  PageContainer, 
  PageHeader, 
  PageTitle,
  ContentContainer 
} from "../styles/PageTitleStyle";
import PageLayout from "../components/PageLayout";
import axios from "axios";
import Footer from "../components/Footer";

function Architecture() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    axios.get('/projects')
      .then(response => {
        setProjects(response.data);
      })
      .catch(error => {
        console.error('Error fetching projects:', error);
      });
  }, []);

  return (
    <PageLayout>
      <PageContainer>
        <ContentContainer>
          <PageHeader>
            <PageTitle>Architecture</PageTitle>
          </PageHeader>
          <Gallery>
            {projects.map((project) => (
              <Link to={`/architecture/${project._id}`} key={project.id} style={{ textDecoration: 'none' }}>
                <GalleryItem big={project.big}>
                  <Image src={project.images[0]} alt={project.title} />
                  <Overlay className="overlay">
                    <Title>{project.title}</Title>
                    <Tags>{project.tags.join(', ')}</Tags>
                    <ViewText>View</ViewText>
                  </Overlay>
                </GalleryItem>
              </Link>
            ))}
          </Gallery>
          <Footer />
        </ContentContainer>
      </PageContainer>
    </PageLayout>
  );
}

export default Architecture;
